module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-32.330dddef.png";